import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function DeleteModal({ show, onHide, onConfirm }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className='border-0'>
      </Modal.Header>
      <Modal.Body className="text-center">
        <h4 className='mb-3 fw-bold'>Czy na pewno chcesz usunąć tę treść?</h4>
        <p>Tej czynności nie można cofnąć.</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center gap-2 border-0">
        <Button variant="secondary" onClick={onHide}>
          Nie, nie usuwaj
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Tak, usuń
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;